/** The Coming up piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { ComingUpEvents } from './contract';
import { ComingUpView } from './ComingUpView';
import { useComingUp } from './useComingUp';

export { ComingUpView, useComingUp };

export function ComingUp(props: PieceInput<ComingUpEvents>) {
  return <ComingUpView {...useComingUp(props)} />;
}
